<template>
    <b-input-group>
                            <template v-slot:prepend>
                            <b-input-group-text>+7</b-input-group-text>
                            </template>
                            <b-form-input
                                type="tel" 
                                v-model="phone"
                                name="phone"
                                id="phone"
                                placeholder="(555) 555-5555"
                                autocomplete="tel"
                                maxlength="14"
                                v-phone
                                pattern="[(][0-9]{3}[)] [0-9]{3}-[0-9]{4}"
                                required
                            > </b-form-input>
                        </b-input-group>
</template>

<script>
export default {
    name: 'telephoneInput',
    directives: {
        phone: {
            bind(el) { el.oninput = function(e) {
                if (!e.isTrusted) {
                    return;
                }
                const x = this.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                this.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                el.dispatchEvent(new Event('input'));
                };
                }
        }
    },
    data() {
        return {
            phone: this.current
        };
    },
    props: {
        current: String
    },
    mounted() {
        this.phone = this.phone.replace('+7', '');
        const x = this.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
        console.log(this.phone);
    },
    watch: {
        phone(evt) {
            evt = evt.replace('(', '');
            evt = evt.replace(')', '');
            evt = evt.replace('-', '');
            evt = evt.replace(' ', '');
            this.$emit('input', '+7' + evt);
        }
    }
};
</script>

<style lang="scss" scoped>
input#phone::placeholder {
    color: lightgray;
}
</style>